import React, { Component } from "react";
import {
  Route,
  Switch,
  Redirect,
  withRouter,
} from "react-router-dom";

import utils from "./utils/utils";
import ErrorBoundary from "./components/ErrorBoundary";

import appUserInstallOrEnter from "./pages/Admin/Install/index";

import Authentication from "./pages/Account/Authentication";
import BindingStore from "./pages/Account/BindingStore";
import ResetPassword from "./pages/Account/ResetPassword";

import dashboard from "./pages/Admin/Dashboard/index";
import ProductSelection from "./pages/Admin/ProductSelection/index";
import ProductSelectionDetail from "./pages/Admin/ProductSelection/Details/index";
import ProductManagement from "./pages/Admin/ProductManagement/index";
import VariantDetail from "./pages/Admin/ProductManagement/ProductDetail/index";
import SourcingDetail from "./pages/Admin/ProductSelection/SourcingDetail/index";
import FreightCalculation from "./pages/Admin/FreightCalculation/index";
import RecommendedApps from "./pages/Admin/RecommendedApps/index";
import CustomService from "./pages/Admin/CustomService/index";
import PartnerShip from "./pages/Admin/PartnerShip/index";
import CustomPackaging from "./pages/Admin/CustomPackaging/index";
import CustomPackagingDetail from "./pages/Admin/CustomPackaging/components/PackageDetail/index";
import RedeemProducts from "./pages/Admin/RedeemProducts/index";
import RedeemProductsDetail from "./pages/Admin/RedeemProducts/components/RedeemProductsDetail/index";

import Inventory from "./pages/Admin/Inventory/index";

import OrderFulfillment from "./pages/Admin/OrderFulfillment/index";
import ShoppingCart from "./pages/Admin/ShoppingCart/index";

import General from "./pages/Admin/Settings/General/index";
import Language from "./pages/Admin/Settings/Language/index";
// import Billing from "./pages/Admin/Settings/Billing/index";
import PlanSetting from "./pages/Admin/Settings/PlanPage/index";
import Notification from "./pages/Admin/Settings/Notification/index";
import PricingRules from "./pages/Admin/Settings/PricingRules/index";
// import Shipping from "./pages/Admin/Settings/Shipping/index";
import Wallet from "./pages/Admin/Settings/Wallet/index";
import Purchase from "./pages/Admin/Purchase/index";
import InventoryPurchase from "./pages/Admin/InventoryPurchase/index";
import HistoryLog from "./pages/Admin/HistoryLog/index";
import PointsPage from "./pages/Admin/PointsPage/index";
import PointsLog from "./pages/Admin/PointsLog/index";
import PointsCoupon from "./pages/Admin/PointsCoupon/index";
import PointsPurchase from "./pages/Admin/PointsPurchase/index";
import PointsBlackPurchase from "./pages/Admin/PointsBlackPurchase/index";
import PointsReferralsLog from "./pages/Admin/PointsReferralsLog/index";
import InventoryHistoryLog from "./pages/Admin/InventoryHistoryLog/index";
import OrderPayment from "./pages/Admin/Settings/OrderPayment/index";

import Messages from "./pages/Admin/Messages/index";

// Error 404 / 500
import NotFound from "./pages/Admin/Error/pageNotFound";
import ErrorPage from "./pages/Admin/Error/error";
import CookieError from "./pages/Admin/Error/cookieError";

import PrivacyPolicy from "./pages/Admin/PrivacyPolicy/index";
import LandingPage from "./pages/Admin/LandingPageBuilder/index";
import BlackFriday from './pages/Admin/BlackFriday/index';//黑色星期五活动
import SubscriptionPaid from "./pages/Admin/SubscriptionPaid/index";

import Coupon from "./pages/Admin/Coupon/index";
import UpgradeNotify from "./pages/Public/UpgradeNotify";
class BasicRoute extends Component {
  requireAuth = (Layout, props) => {
    const isShopify = window.shopify;
    // 登录验证
    const params = new URLSearchParams(props.location.search);
    let domain = params.get("domain");
    let usertoken = params.get("usertoken");
    let shopOwner = params.get("shop_owner");
    let appAuth = params.get("authority");
    let storeName = params.get("store_name"); // shopify店铺网站名称
    /**
     * App 内嵌模式下要清除之前的授权信息
     */
    if (isShopify) {
      utils.setStore("S_AUTHORIZATION", "");
      appAuth = null;
    }

    /**
     * 如果不存在 host 和 shop 表示是从我们超管后台或者平台登录的，不进行搭桥模式
     */
    if (!isShopify) {
      if (appAuth) {
        // 浏览器cookie是否禁用判断
        if (navigator.cookieEnabled === false) {
          window.location.href = "/admin/cookie-error";
          return false;
        }

        utils.setStore("S_AUTHORIZATION", appAuth);
      }

      if (storeName) {
        window.S_STORE_NAME = storeName;
        utils.setStore("S_STORE_NAME", storeName);
      }

      if (shopOwner) {
        window.S_SHOP_OWNER = shopOwner;
        utils.setStore("S_SHOP_OWNER", shopOwner);
      }

      if (domain && usertoken) {
        utils.setStore("S_SHOP_DOMAIN", domain);
        utils.setStore("S_USER_TOKEN", usertoken);
      }

      if (appAuth && appAuth.length >= 32) {
        return <Layout {...props} />;
      }
    }
    return <Layout {...props} />;
  };
  render() {
    return (
      <div>
        <ErrorBoundary>
          <Switch>
            {/* 版本升级跳转页面 */}
            <Route path="/upgrade/notify" component={UpgradeNotify} />
            {/* 用户从Shopify Admin后台 进入或者安装App入口 */}
            <Route path="/auth/install" component={appUserInstallOrEnter} />

            {/* 注册登录模块 */}
            <Route path="/register" component={Authentication} />
            <Route path="/login" component={Authentication} />
            <Route path="/reset_password" component={ResetPassword} />
            <Route
              path="/binding_store"
              component={(props) => this.requireAuth(BindingStore, props)}
            />
            {/* App业务模块 */}
            <Route
              exact
              path="/"
              render={() => <Redirect to="/admin/dashboard"></Redirect>}
            />
            <Route
              exact
              path="/admin"
              render={() => <Redirect to="/admin/dashboard"></Redirect>}
            />
            <Route
              path="/admin/dashboard"
              exact
              render={(props) => this.requireAuth(dashboard, props)}
            />
            <Route
              path="/admin/product_selection"
              exact
              component={(props) => this.requireAuth(ProductSelection, props)}
            />
             <Route
              path="/admin/product_selection/product-info"
              exact
              component={(props) => this.requireAuth(ProductSelectionDetail, props)}
            />
             <Route
              path="/admin/product_selection/sourcing-detail"
              exact
              component={(props) => this.requireAuth(SourcingDetail, props)}
            />
             <Route
              path="/admin/product_management"
              exact
              component={(props) => this.requireAuth(ProductManagement, props)}
            />
            <Route
              path="/admin/product_management/product/:id"
              exact
              component={(props) => this.requireAuth(VariantDetail, props)}
            />
            <Route
              path="/admin/dropshipman_products"
              render={() => <Redirect to="/admin/product_management"></Redirect>}
            />
            <Route
              path="/admin/products"
              exact
              render={() => <Redirect to="/admin/product_management"></Redirect>}
            />

            <Route
              path="/admin/customService/custom-packaging/packaging-info"
              exact
              component={(props) =>
                this.requireAuth(CustomPackagingDetail, props)
              }
            />
            <Route
              path="/admin/redeem_products"
              exact
              component={(props) =>
                this.requireAuth(RedeemProducts, props)
              }
            />
             <Route
              path="/admin/redeem_products/product-info"
              exact
              component={(props) =>
                this.requireAuth(RedeemProductsDetail, props)
              }
            />

            <Route
              path="/admin/wallet"
              exact
              component={(props) => this.requireAuth(Wallet, props)}
            />

            <Route
              path="/admin/customService"
              exact
              component={(props) => this.requireAuth(CustomService, props)}
            />
            <Route
              path="/admin/customService/calculate-shipping"
              exact
              component={(props) => this.requireAuth(FreightCalculation, props)}
            />
            <Route
              path="/admin/customService/custom-packaging"
              exact
              component={(props) => this.requireAuth(CustomPackaging, props)}
            />
            {/* purchase */}
            <Route
              path="/admin/customService/purchase"
              exact
              component={(props) => this.requireAuth(Purchase, props)}
            />
            <Route
              path="/admin/customService/pur_inventory"
              exact
              component={(props) => this.requireAuth(InventoryPurchase, props)}
            />
            {/* history */}
            <Route
              path="/admin/customService/history_log"
              exact
              component={(props) => this.requireAuth(HistoryLog, props)}
            />
            <Route
              path="/admin/customService/invent_history_log"
              exact
              component={(props) => this.requireAuth(InventoryHistoryLog, props)}
            />
            <Route
              path="/admin/customService/inventory"
              exact
              component={(props) => this.requireAuth(Inventory, props)}
            />
            <Route
              path="/admin/customService/landing-page-build"
              exact
              component={(props) => this.requireAuth(LandingPage, props)}
            />
             <Route
              path="/admin/points"
              exact
              component={(props) => this.requireAuth(PointsPage, props)}
            />
             <Route
              path="/admin/points_log"
              exact
              component={(props) => this.requireAuth(PointsLog, props)}
            />
             <Route
              path="/admin/points_coupon"
              exact
              component={(props) => this.requireAuth(PointsCoupon, props)}
            />
             <Route
              path="/admin/referrals_log"
              exact
              component={(props) => this.requireAuth(PointsReferralsLog, props)}
            />
            <Route
              path="/admin/points_purchase"
              exact
              component={(props) => this.requireAuth(PointsPurchase, props)}
            />
            <Route
              path="/admin/black_points_purchase"
              exact
              component={(props) => this.requireAuth(PointsBlackPurchase, props)}
            />
            <Route
              path="/admin/partnerShip"
              exact
              component={(props) => this.requireAuth(PartnerShip, props)}
            />
            
            {/* 订阅付费页面 */}
            <Route
              path="/admin/subscribe"
              exact
              component={(props) => this.requireAuth(SubscriptionPaid, props)}
            />
            {/* 订单重构后路由 */}
           
            <Route
              path="/admin/order_fulfillment"
              render={(props) => this.requireAuth(OrderFulfillment, props)}
            />
            <Route
              path="/admin/shopping_cart"
              exact
              component={(props) => this.requireAuth(ShoppingCart, props)}
            />
            <Route
              path="/admin/settings"
              exact
              component={(props) => this.requireAuth(General, props)}
            />
            <Route
              path="/admin/settings/general"
              exact
              component={(props) => this.requireAuth(General, props)}
            />
            <Route
              path="/admin/settings/notification"
              exact
              component={(props) => this.requireAuth(Notification, props)}
            />
            <Route
              path="/admin/settings/price"
              exact
              component={(props) => this.requireAuth(PricingRules, props)}
            />
            {/* <Route
              path="/admin/settings/shipping"
              exact
              component={(props) => this.requireAuth(Shipping, props)}
            /> */}
            {/* <Route
              path="/admin/settings/affiliate"
              exact
              component={(props) =>
                this.requireAuth(AliExpressAffiliate, props)
              }
            /> */}
            {/* <Route
              path="/admin/settings/address"
              exact
              component={(props) => this.requireAuth(AddressManagement, props)}
            /> */}
            <Route
              path="/admin/settings/payment"
              exact
              component={(props) => this.requireAuth(OrderPayment, props)}
            />
            {/* <Route
              path="/admin/settings/billing"
              exact
              component={(props) => this.requireAuth(Billing, props)}
            /> */}
             <Route
              path="/admin/plan_setting"
              exact
              component={(props) => this.requireAuth(PlanSetting, props)}
            />
            
            <Route
              path="/admin/settings/language"
              exact
              component={(props) => this.requireAuth(Language, props)}
            />
           
            <Route
              path="/admin/messages"
              exact
              component={(props) => this.requireAuth(Messages, props)}
            />
            <Route
              path="/admin/recommended-apps"
              exact
              component={(props) => this.requireAuth(RecommendedApps, props)}
            />
            {/*优惠券模块*/}
            <Route
              path="/admin/coupon"
              exact
              component={(props) => this.requireAuth(Coupon, props)}
            />
            

            {/* 黑色星期五 */}
            <Route path="/admin/black-friday" exact component={props => this.requireAuth(BlackFriday, props)} />
            <Route path="/privacy-policy" exact component={PrivacyPolicy} />

            {/* 浏览器禁用cookie */}
            <Route path="/admin/cookie-error" component={CookieError} />

            {/* 异常处理 500 */}
            <Route path="/admin/error" component={ErrorPage} />

            {/* 异常处理 404 */}
            <Route path="/404" component={NotFound} />
            <Redirect to="/404"></Redirect>
          </Switch>
        </ErrorBoundary>
      </div>
    );
  }
}

export default withRouter(BasicRoute);
